<div class="dialog--print">
  <div class="dialog__content">
    <div class="dialog__title">{{ 'webPos.PrintDocument.Title' | translate }}</div>
    <div class="dialog__message">{{ 'webPos.PrintDocument.Message' | translate }}</div>
    <div class="dialog__actions">
      <app-action-button
        [buttonSize]="ActionButtonSize.Normal"
        [buttonType]="ActionButtonType.Confirm"
        (clicked)="openInNewTab()">
        <span class="dialog__button-content">
          <fa-icon class="dialog__button-icon" [icon]="['fas', 'print']"></fa-icon>
          {{ 'webPos.PrintDocument.Button' | translate }}
        </span>
      </app-action-button>
    </div>
  </div>
</div>
